import { useTranslation } from 'react-i18next'

import { usePageTitle } from '@/lib/use-page-title'

export const OAuthCallback = () => {
  const { t } = useTranslation('auth')
  usePageTitle('oauth_callback_title', 'auth')

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <p className="text-sm text-muted-foreground">{t('oauth_callback_title')}</p>
    </main>
  )
}
